import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import { z } from "zod"
import { PROJECT_STATUSES } from "@/features/project-status/core/projectStatus"
import { reportsQueryKeys } from "@/lib/queryKeys"
import {
  getPresentationLocationsReport,
  type PresentationLocationsParams,
} from "../../server/presentationLocationsServer"

export const PresentationLocationsSearchParams = z.object({
  status: z.enum(PROJECT_STATUSES).optional(),
  countryIds: z.array(z.string()).optional(),
  pageIndex: z.coerce.number().int().min(0).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
})

export type PresentationLocationsSearchValues = z.infer<typeof PresentationLocationsSearchParams>

export const PRESENTATION_LOCATIONS_DEFAULTS = {
  status: "approved" as const,
  pageIndex: 0,
  pageSize: 25,
}

export const applyPresentationLocationsDefaults = (
  s: PresentationLocationsSearchValues,
): PresentationLocationsParams => ({
  status: s.status ?? PRESENTATION_LOCATIONS_DEFAULTS.status,
  countryIds: s.countryIds,
  pageIndex: s.pageIndex ?? PRESENTATION_LOCATIONS_DEFAULTS.pageIndex,
  pageSize: s.pageSize ?? PRESENTATION_LOCATIONS_DEFAULTS.pageSize,
})

export const presentationLocationsQuery = (params: PresentationLocationsParams) =>
  queryOptions({
    queryKey: reportsQueryKeys.presentationLocations(params),
    queryFn: () => getPresentationLocationsReport({ data: params }),
    placeholderData: keepPreviousData,
  })
